import React, { useContext } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import { ShopContext } from '../context/ShopContext';
import ProductItem from './ProductItem'; // Adjust the import path as necessary


const RelatedProduct = () => {
  const { products } = useContext(ShopContext); // Assuming products are provided in the ShopContext

  return (
    <div className="similar_campaigns_sec ">
        <div className="swiper similar_campaigns">
               
                <div className="swiper-wrapper">
                    <div className="swiper-slide">

                       
                        


      <Swiper
        spaceBetween={20}
        slidesPerView={4}
        breakpoints={{
            // When window width is <= 640px
            320: {
              slidesPerView: 1, // 1 slide on mobile
            },
            // When window width is between 641px and 1024px
            641: {
              slidesPerView: 2, // 2 slides on small tablets
            },
            // When window width is >= 1025px
            1025: {
              slidesPerView: 4, // 4 slides on larger screens
            },
          }}
        >
       
          {products.map((product, index) => (
            <SwiperSlide key={`${product.id}-${index}`}>
              <ProductItem
                id={product.id}
                image={product.Contributionimg} // Assuming Contributionimg is an array of image paths
                title={product.title}
                hoursLeft={product.hoursLeft}
                sponsors={product.sponsors}
                taxBenefit={product.taxBenefit}
                target={{ left: product.targetLeft, goal: product.targetGoal }} // Assuming target is an object
                isTaxBenefit={product.isTaxBenefit}
              />
            </SwiperSlide>
        ))}
      </Swiper>
      </div>
      </div>
       </div>
    </div>
  );
};

export default RelatedProduct;
